<template>
  <div class="chat-container">
    <div class="row match-height">
      <b-col
        v-for="chat in chats"
        :key="chat.id"
        cols="12"
        md="6"
        lg="4"
      >
        <b-card
          class="card-central-atendimento text-center"
          :title="chat.name"
          img-src="https://manyconvert.com/assets/img/logo-ofc.svg"
          img-alt="Central"
          img-top
        >
          <b-card-text>
            Selecione para acessar a central de atendimento: <strong>{{ chat.name }}</strong>.
          </b-card-text>

          <b-button
            variant="primary"
            @click="selectChat(chat)"
          >
            Acessar Central
          </b-button>
        </b-card>
      </b-col>
    </div>
  </div>
</template>

<script>
import { buscaChats, buscaChatsTeste } from '../../functions/basics/chat'

export default {
  name: 'ChatSelector',
  data() {
    return {
      chats: [], // Lista de centrais
    }
  },
  mounted() {
    this.loadChats()
  },
  methods: {
    async loadChats() {
      try {
        const response = await buscaChatsTeste()
        this.chats = Array.isArray(response.chats) ? response.chats : [response.chats]
      } catch (err) {
        console.error('Erro ao carregar chats', err)
      }
    },
    selectChat(chat) {
      const url = `/chat/${chat.chat_token}`
      window.location.href = url
    },
    mockApi() {
      return Promise.resolve({
        chats: {
          id: 1,
          name: 'ManyConvert',
          chat_token: 'teste',
          whatsapp_phone_number_id: '381237951750381',
          access_token: 'EAANKctOZCbRcBO0...',
          magazord_token: '174545fe849440c2...',
          magazord_api_link: 'https://monteleste.painel.magazord.com.br',
          magazord_key: 'maga$5050',
          whatsapp_business_id: '420228274514368',
        },
      })
    },
  },
}
</script>

<style scoped>
.chat-container {
  min-height: 100dvh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  box-sizing: border-box;
}

.row.match-height {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 1rem;
  margin: 0;
}

.row.match-height > [class*='col-'] {
  padding: 0;
}

.card-central-atendimento {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.card-central-atendimento img {
  width: 60%;
  height: auto;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .chat-container {
    padding: 0.75rem;
    min-height: 100dvh;
    height: 100dvh;
  }

  .row.match-height {
    gap: 0.75rem;
  }

  .card-central-atendimento img {
    width: 50%;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .chat-container {
    padding: 1rem;
  }

  .card-central-atendimento img {
    width: 55%;
  }
}

@media (min-width: 1025px) {
  .chat-container {
    padding: 1.5rem;
  }
}

@supports not (height: 100dvh) {
  .chat-container {
    min-height: 100vh;
    height: 100vh;
  }
  
  @media (max-width: 768px) {
    .chat-container {
      min-height: calc(100vh - 60px);
      height: calc(100vh - 60px);
    }
  }
}
</style>